import { render } from "./AddWallet.vue?vue&type=template&id=6fbacd1a"
import script from "./AddWallet.vue?vue&type=script&lang=js"
export * from "./AddWallet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__